
import { supabase } from '../lib/supabaseClient';

export interface AppSettings {
    landlord_feature_enabled: boolean;
}

// Default settings in case of error or missing DB row
const DEFAULT_SETTINGS: AppSettings = {
    landlord_feature_enabled: true
};

export const AppSettingsService = {
    getSettings: async (): Promise<AppSettings> => {
        try {
            const { data, error } = await supabase
                .from('app_settings')
                .select('*');

            if (error) {
                console.error('Error fetching settings:', error);
                return DEFAULT_SETTINGS;
            }

            const settings: any = { ...DEFAULT_SETTINGS };

            data?.forEach((row: { key: string; value: any }) => {
                if (row.key === 'landlord_feature_enabled') {
                    settings.landlord_feature_enabled = row.value;
                }
            });

            return settings;
        } catch (err) {
            console.error('Settings fetch exception:', err);
            return DEFAULT_SETTINGS;
        }
    },

    updateSetting: async (key: string, value: any): Promise<{ error: any }> => {
        try {
            const { error } = await supabase
                .from('app_settings')
                .upsert({ key, value })
                .select();

            return { error };
        } catch (err) {
            return { error: err };
        }
    }
};
